import axios from 'axios'

export const sendApiRequest = async (urlPart, data = {}, method = 'get', options = {}) => {
  const url = `https://api.thegirlandherpiano.com/api/${urlPart}?populate=*`;
  
  try {
    const response = await axios({
      method,
      url,
      data,
      ...options
    });

    return {
      status: 'success',
      data: response.data
    };
  } catch (error) {
    const err = {
      status: 'failure'
    };

    if (error.response) {
      const { data: { error: responseError } = {} } = error.response;
      
      if (responseError?.details?.messages) {
        err.formMessages = responseError.details.messages;
      }
      
      if (responseError) {
        err.data = responseError;
      }
    }

    return err;
  }
};